document.addEventListener("DOMContentLoaded", function () {
  var buttons = document.getElementsByClassName(
    "ticket-pricing__option-button"
  );
  for (var i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", function (e, i) {
      var currentButton = e.target;

      if (!currentButton) {
        return;
      }

      var targetPane = currentButton.getAttribute("data-pane-option");

      if (!targetPane) {
        return;
      }

      var content = currentButton.parentNode.closest(
        ".ticket-pricing__content"
      );

      if (!content) {
        return;
      }

      var innerButtons = content.getElementsByClassName(
        "ticket-pricing__option-button"
      );
      for (var i = 0; i < innerButtons.length; i++) {
        innerButtons[i].classList.remove("active");
      }

      currentButton.classList.add("active");

      var panes = content.getElementsByClassName("ticket-pricing__pane");
      for (var i = 0; i < panes.length; i++) {
        panes[i].classList.remove("active");
      }

      var activePane = content.querySelector(
        '[data-pane="' + targetPane + '"]'
      );

      if (activePane) {
        activePane.classList.add("active");
      }
    });
  }
});
